import React from 'react';
import {LocalVideoTrack} from 'twilio-video';
import VideoTrack from '../VideoTrack/VideoTrack';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

export default function LocalVideoPreview() {
    const {localTracks} = useVideoContext();

    const videoTrack = localTracks.find(track => track.name.includes('camera')) as LocalVideoTrack;
    const sizeDivide = 2
    const videoWidgh = 1920 / sizeDivide
    const videoHeight = 1080 / sizeDivide

    const videoStyle = {
        width: `${videoWidgh}px`,
        height: `${videoHeight}px`
    }

    return videoTrack ? (
        <div style={videoStyle}>
            <VideoTrack track={videoTrack} isLocal/>
        </div>
    ) : null;
}
